module.exports = __webpack_public_path__ + "static/rule.76abb7cd.png";